/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import closIcon from '../img/icon-help-close.svg';
import * as styles from './QAModal.module.styl';

interface QAModalProps {

  /**
   * QA
   * @required
   * @type {q: string, a:string}[]
   * @memberof QAModalProps
   */
  qa: {q: string, a:string}[];

  /**
   * モーダルの表示管理
   * @required
   * @type boolean
   * @memberof QAModalProps
   */
  isActive: boolean;

  /**
   * 閉じる押下時のコールバック
   * @required
   * @type Function
   * @memberof QAModalProps
   */
  handleCloseModal: Function;
}

// 申込みフォーム各セクションのQAモーダル
const QAModal: React.FC<QAModalProps> = (props) => {
  const {
    qa,
    isActive,
    handleCloseModal,
  } = props;

  return (
    <div className={`${styles.popupBox} is-size-4 ${isActive ? '' : 'is-hidden'}`}>
      <div className="" id="modal">
        <div className={`${styles.modalCansell} is-flex`}>
          <p className={`${styles.helpTitle} has-text-weight-bold`}>現住所について</p>
          <div
            className={styles.close}
            role="button"
            tabIndex={-1}
            onClick={() => handleCloseModal()}
          >
            <img src={closIcon} width="52" alt="閉じる" />
          </div>
        </div>
        <div className={styles.modalContents}>
          {
            qa.map((q, index) => (
              <div key={`${index}_${q.q}`} className={`${styles.helpContents} is-margin-bottom-7`}>
                <div className="is-padding-top-3">
                  <p className={`${styles.helpSubtitle} has-text-weight-semibold`}>{q.q}</p>
                  <p className={`${styles.helpText} is-margin-top-3 is-padding-bottom-7 has-text-weight-normal has-text-primary`}>{q.a}</p>
                </div>
              </div>
            ))
          }
        </div>
      </div>
      <div
        className={styles.mask}
        role="button"
        tabIndex={-1}
        onClick={() => handleCloseModal()}
      />
      <div className={styles.maskClose}>
        <div
          className={`button is-large has-text-weight-normal ${styles.iconClose}`}
          role="button"
          tabIndex={-1}
          onClick={() => handleCloseModal()}
        >
          閉じる
        </div>
      </div>
    </div>
  );
};
export default QAModal;
